import { render } from "./ClientEstadoCuenta.vue?vue&type=template&id=296e6380&scoped=true"
import script from "./ClientEstadoCuenta.vue?vue&type=script&lang=js"
export * from "./ClientEstadoCuenta.vue?vue&type=script&lang=js"

import "./ClientEstadoCuenta.vue?vue&type=style&index=0&id=296e6380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296e6380"]])

export default __exports__